import Heading from '@/components/pageheader_component.vue';
import axios from 'axios';
import moment from 'moment';
import LoaderPopover from '@/components/loaderpopover_component.vue';
export default {
    name: 'addCustomer',
    components:{
        Heading,LoaderPopover
    },
    data(){
        return {
            url:window.location.protocol+'//'+window.location.hostname+'/index.php/',
            salons : [],
            salon_selected : '',
            tag_type : [],
            notification_type : ["email","text"],
            selected_cust_email:"",
            display_in_all_bookings :false,
            scrollHeight : window.scrollY,
            customer_base64_url :'',
            first_name:'',
            last_name:'',
            cust_email:'',
            cust_mobile:'',
            address_one:'',
            address_two:'',
            city:'',
            state:'',
            country:'',
            pin_code:'',
            cust_notes:'',
            cust_time_zone:'',
            email_exists:'',
            send_email:false,
            send_text:false,
            is_banned:false,
            has_allergy:false,
            pay_fullpayment:false,
            is_vip:false,
            old_image_url:'',
            image_changed:false,
            first_name_validation:'',
            last_name_validation:'',
            mobile_validation:'',
            address_validation:'',
            address_two_validation:'',
            state_validation:'',
            country_validation:'',
            city_validation:'',
            pincode_validation:'',
            all_validations_passed:true,
            component_destroyed:false,
            custprofile_url : '',
            cust_country_isd_code : '61',
            cust_id: '',
            title:'Add Customer'

        }
    },
    created(){
        this.$session.remove('created_cust_id');
        if(this.$session.has('edit_cust_id')){
            this.title = 'Edit Customer'
            this.cust_id = this.$session.get('edit_cust_id');
            this.get_customer_details();
        }
    },
    mounted() {
        // this.getStore();
        document.getElementsByClassName('footer')[0].hidden = true;
        window.addEventListener("scroll", this.footerEnable);
        this.selected_cust_email = '';
    },
    beforeDestroy() {
        this.component_destroyed = true;
      },
    methods:{

        get_customer_details(){
            axios.post(this.$store.state.api +'customer/get_customer_details',{
                "cust_id" :this.cust_id}).then(response => {
                    var customer_details = response.data.result[0];
                    if(customer_details.cust_first_name)this.first_name = customer_details.cust_first_name;
                    if(customer_details.cust_last_name)this.last_name = customer_details.cust_last_name;
                    if(customer_details.cust_email)this.cust_email = customer_details.cust_email;
                    this.selected_cust_email = customer_details.cust_email;
                    if(customer_details.cust_mobile)this.cust_mobile = customer_details.cust_mobile;
                    if(customer_details.cust_add1)this.address_one = customer_details.cust_add1;
                    if(customer_details.cust_add2)this.address_two = customer_details.cust_add2;
                    if(customer_details.cust_city)this.city = customer_details.cust_city;
                    if(customer_details.cust_state)this.state = customer_details.cust_state;
                    if(customer_details.cust_country)this.country = customer_details.cust_country;
                    if(customer_details.cust_pin)this.pin_code = customer_details.cust_pin;
                    if(customer_details.cust_notes)this.cust_notes = customer_details.cust_notes;
                    this.cust_country_isd_code = customer_details.cust_country_isd_code;
                    if(!customer_details.cust_picture || (customer_details.cust_picture == 'null'))customer_details.cust_picture = '';
                    this.custprofile_url = customer_details.cust_picture;
                    this.old_image_url = customer_details.cust_picture;
                    this.customer_base64_url = customer_details.cust_picture;
                    this.notification_type = [];
                    if(customer_details.has_allergy)this.tag_type.push("allergy");
                    if(customer_details.is_banned)this.tag_type.push("banned");
                    if(customer_details.pay_fullpayment)this.tag_type.push("full_payment");
                    if(customer_details.is_vip)this.tag_type.push("vip");
                    if(customer_details.show_cust_notes_flag)this.display_in_all_bookings = true;
                    if(customer_details.send_email)this.notification_type.push('email');
                    if(customer_details.send_text)this.notification_type.push('text')
                })
        },
        imageInput(){
            this.$refs.cust_file.click();
        },

        previewFile(e) {
            if(e.target.files.length > 0){
                const file = e.target.files[0];
                this.custprofile_url = URL.createObjectURL(file);
                this.convertToBase64(file).then(image_url => {
                    this.customer_base64_url = image_url;
                    this.image_changed = true;
                });
            } 
        },
        check_customer_exists(){
            if(!this.cust_email) this.email_exists = 'Please enter the Email Address';
            else if(this.cust_email.includes("'"))this.email_exists = 'Please enter a valid Email Address';
            else{
                if(this.$store.state.regx.test(this.cust_email)){
                    axios.post(this.$store.state.api +'customer/exists_with_store',{
                        owner_id:this.$store.state.user_id,
                        cust_email:this.cust_email
                    }).then(result=>{
                        if(result.data.response.length && (this.cust_email != this.selected_cust_email)){
                            this.email_exists = 'This Email Address already exists, Please type another one'
                        }
                        else this.email_exists = '';
                    })
                }
                else this.email_exists = 'Please enter a valid Email Address'
            }
            
        },
        first_name_validation_check(){
            this.first_name = this.first_name.trim();
            this.first_name = this.first_name.replace(/  +/g, ' ')
            this.first_name_validation = '';
            if(this.first_name.length == 0){
                this.all_validations_passed = false 
                this.first_name_validation = 'Please fill the first name'
            }
            else if((/<img.*|<script.*|<style.*|<embeded.*/ig).test(this.first_name)){
                this.all_validations_passed = false 
                this.first_name_validation = 'Enter a valid first name'
            }
        },
        last_name_validation_check(){
            this.last_name = this.last_name.trim();
            this.last_name_validation = ''
            this.last_name = this.last_name.replace(/  +/g, ' ')
            if(this.last_name.length == 0){
                this.all_validations_passed = false 
                this.last_name_validation = 'Please fill the last name'
            }
            else if((/<img.*|<script.*|<style.*|<embeded.*/ig).test(this.last_name)){
                this.all_validations_passed = false 
                this.last_name_validation = 'Enter a valid last name'
            }
        },
        address1_validation_check(){
            this.address_one = this.address_one.trim();
            this.address_validation = ''
            this.address_one = this.address_one.replace(/  +/g, ' ')
            if((/<img.*|<script.*|<style.*|<embeded.*/ig).test(this.address_one)){
                this.all_validations_passed = false 
                this.address_validation = 'Enter a valid Address'
            }
        },
        address2_validation_check(){
            this.address_two = this.address_one.trim();
            this.address_two_validation = ''
            this.address_two = this.address_two.replace(/  +/g, ' ')
            if((/<img.*|<script.*|<style.*|<embeded.*/ig).test(this.address_two)){
                this.all_validations_passed = false 
                this.address_two_validation = 'Enter a valid Address'
            }
        },
        state_validation_check(){
            this.state = this.state.trim();
            this.state_validation = ''
            this.state = this.state.replace(/  +/g, ' ')
            if((/<img.*|<script.*|<style.*|<embeded.*/ig).test(this.state)){
                this.all_validations_passed = false 
                this.state_validation = 'Enter a valid State Name'
            }
        },
        country_validation_check(){
            this.country = this.country.trim();
            this.country_validation = ''
            this.country = this.country.replace(/  +/g, ' ')
            if((/<img.*|<script.*|<style.*|<embeded.*/ig).test(this.country)){
                this.all_validations_passed = false 
                this.country_validation = 'Enter a valid Country Name'
            }
        },
        city_validation_check(){
            this.city = this.city.trim();
            this.city_validation = ''
            this.city = this.city.replace(/  +/g, ' ')
            if((/<img.*|<script.*|<style.*|<embeded.*/ig).test(this.city)){
                this.all_validations_passed = false 
                this.city_validation = 'Enter a valid City Name'
            }
        },
        postal_code_validation_check(){
            this.pincode_validation = ''
            
            if(this.pin_code.length >0 && (this.pin_code.length < 4 || this.pin_code.length > 8 || this.pin_code[0] == 0)){
                this.all_validations_passed = false 
                this.pincode_validation = 'Please enter a valid Postal Code'
            }
        },

        mobile_number_validation_check(){
            this.mobile_validation = '';
            if(this.cust_mobile.length <= 0){
                this.all_validations_passed = false 
                this.mobile_validation = 'Please enter the mobile number'
            }
            else if(this.cust_mobile.length < 9 || this.cust_mobile.length > 11){
                this.all_validations_passed = false 
                this.mobile_validation = 'Use a valid mobile number, Eg: 1234567889 '
            }
        },
        validation_check(){
            this.all_validations_passed = true;
            this.check_customer_exists();
            this.mobile_number_validation_check();
            this.first_name_validation_check();
            this.last_name_validation_check();
            this.postal_code_validation_check();
            this.city_validation_check();
            this.country_validation_check();
            this.state_validation_check();
            this.address1_validation_check();
            if(this.email_exists.length){
                this.all_validations_passed = false
            }
            if(!this.cust_email) this.email_exists = 'Please enter the Email Address'
        },

        save_customer(){
            this.Constants.time_zones.forEach(zone => {
                if(this.cust_country_isd_code == zone.country_code){this.cust_time_zone = zone.time_zone}
            })
            this.validation_check()
            if(this.tag_type.indexOf("vip") !== -1){
                this.is_vip = true
            }
            else this.is_vip = false

            if(this.tag_type.indexOf("banned") !== -1){
                this.is_banned = true
            }
            else this.is_banned = false

            if(this.tag_type.indexOf("allergy") !== -1){
                this.has_allergy = true
            }
            else this.has_allergy = false

            if(this.tag_type.indexOf("full_payment") !== -1){
                this.pay_fullpayment = true
            }
            else this.pay_fullpayment = false

            if(this.notification_type.indexOf("email") !== -1){
                this.send_email = true
            }
            else this.send_email = false
            if(this.notification_type.indexOf("text") !== -1){
                this.send_text = true
            }
            else this.send_text = false;
            if(this.all_validations_passed){
                this.$store.state.loader_popup = true;
                this.first_name = this.first_name.toLowerCase();
                this.last_name = this.last_name.toLowerCase();
                
                axios.post(this.$store.state.api +'customer/save_customer',{
                    "image_url" :this.customer_base64_url,
                    "owner_id":this.$store.state.user_id,
                    "cust_first_name":this.first_name.charAt(0).toUpperCase() + this.first_name.slice(1),
                    "cust_last_name":this.last_name.charAt(0).toUpperCase() + this.last_name.slice(1),
                    "cust_email":this.cust_email.toLowerCase(),
                    "cust_mobile":this.cust_mobile,
                    "cust_add1":this.address_one,
                    "cust_add2":this.address_two, 
                    "cust_city":this.city,
                    "cust_state":this.state,
                    "cust_country":this.country,
                    "cust_pin":this.pin_code,
                    "cust_notes":this.cust_notes,
                    "cust_picture":this.old_image_url,  
                    "cust_created_by":this.$store.state.user_id, 
                    "cust_created_date":moment(new Date()).format('yyyy-MM-DD')+" "+moment(new Date()).format('HH:mm:ss'), 
                    "cust_updated_by":this.$store.state.user_id,
                    "cust_updated_date":moment(new Date()).format('yyyy-MM-DD')+" "+moment(new Date()).format('HH:mm:ss'),
                    "cust_country_isd_code": this.cust_country_isd_code,
                    "cust_time_zone":this.cust_time_zone, 
                    "customer_notes":this.cust_notes, 
                    "send_email":this.send_email,
                    "send_text":this.send_text,
                    "show_cust_notes_flag":this.display_in_all_bookings,
                    "is_banned":this.is_banned, 
                    "has_allergy":this.has_allergy, 
                    "pay_fullpayment":this.pay_fullpayment,
                    "is_vip":this.is_vip,
                    "image_changed":this.image_changed,
                    "cust_id":this.cust_id
                }).then(response =>{
                    if(this.cust_id){
                        this.move_to_newbooking(this.cust_id);   
                    }
                    else this.move_to_newbooking(response.data.response.insertId);    
                    this.$store.state.loader_popup = false
                })
            }
        },
        convertToBase64(image_object) {
            return new Promise(resolve => {
                var reader = new FileReader();
                reader.onload = function(event) { resolve(event.target.result); }
                reader.readAsDataURL(image_object);
            });
        },
        footerEnable() {
            this.scrollHeight = window.scrollY;
            if(!this.component_destroyed){
                if(this.scrollHeight > 75){
                    document.getElementsByClassName('footer')[0].hidden = false;
                }
                else{
                    document.getElementsByClassName('footer')[0].hidden = true;
                }
            }
        },
        // async getStore(){
        //     await this.$store.dispatch('getStoreByOwnerId',[this.$store.state.api,this.$store.state.user_id]);

        //     if(Object.keys(this.$store.state.stores_data).length > 0){
        //         this.salons = this.$store.state.stores_data; 
        //     }

        //     this.salon_selected = this.$store.state.stores_data[0].store_id
        // },
        move_to_newbooking(cust_id){
            this.$session.get('rebook') == false;
            this.$session.remove('edit_cust_id')
            if(sessionStorage.getItem('v1_customer_page')){
                sessionStorage.removeItem('v1_customer_page');
                window.location.href = this.url + 'customers/view_my_customers';
            }else{
                if(cust_id != '') this.$session.set('created_cust_id',cust_id);
                this.$router.go(-1);
                // this.$router.push('/newbooking');
            }
        }
    }
    
}